import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  display: 'inline' | 'block' = 'block';

  @Input()
  theme: 'dark' | 'light' = 'dark';

  @Input()
  isCompact = false;

  constructor() { }

  ngOnInit() {
  }

}
